// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"Ribbon_ribbon__ExV_O"};